import React, { FunctionComponent, PropsWithChildren, ReactNode } from 'react';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import MuiDrawer from '@mui/material/Drawer';

import local from './local.module.scss';

interface DrawerProps {
    isOpen: boolean;
    setOpen: (value: boolean) => void;
    title: ReactNode;
    buttons?: ReactNode;
}

const Drawer: FunctionComponent<PropsWithChildren<DrawerProps>> = ({
    isOpen,
    setOpen,
    title,
    buttons,
    children
}) => (
    <MuiDrawer
        anchor='right'
        open={isOpen}
        ModalProps={{
            BackdropProps: {
                classes: { root: local.backdropRoot }
            }
        }}
        PaperProps={{
            classes: { root: local.paperRoot }
        }}
    >
        <div className={classnames(local.container, 'container-column')}>
            <div>
                <div className={local.title}>
                    {title}
                </div>
                <div
                    className={local.closeIconContainer}
                    onClick={() => { setOpen(false); }}
                >
                    <FontAwesomeIcon icon={faClose} className={local.closeIcon} />
                </div>
                {children}
            </div>
            <div className={classnames(local.buttonsContainer, 'container-row')}>
                {buttons}
            </div>
        </div>
    </MuiDrawer>
);

export default Drawer;
